import { Link, useLocation } from "react-router";
import "./header.component.css"
import ButtonComponent from "./button.component";
import { useEffect, useState } from "react";

/**
 * Header component
 * @param absolute Should the header be a solid object?
 * @param className Further class names
 * @param key Further keys
 * @return Header component
 */
function HeaderComponent(
    props: Readonly<{
        absolute: boolean,
        className?: string,
        [key: string]: any,
        isEnglish: boolean,
        setIsEnglish: (newValue: boolean) => void
    }>
) {
    const { absolute, isEnglish, setIsEnglish, className, ...overflowProps } = props;

    const pathname = useLocation().pathname;
    
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen) {
            document.documentElement.style.overflow = "hidden";
        } else {
            document.documentElement.style.overflow = "auto";
        }
    }, [isOpen])

    return (
        <>
            <button className={`burger no-select ${isOpen ? "open" : ""}`} onClick={() => {setIsOpen(!isOpen)}}>
                <div />
                <div />
                <div />
            </button>
            
            <div className={`header ${isOpen ? "open" : ""} ${absolute ? "absolute" : ""} ${className ?? ""}`} {...overflowProps}>
                {
                    isOpen &&
                    <button className="close-button" onClick={() => {setIsOpen(false)}}>
                        <div />
                        <div />
                    </button>
                }
                <Link to="/" onClick={() => {setIsOpen(false)}}>
                    <p className={pathname === "/" ? "current-page" : ""}>Home</p>
                </Link>
                <Link to="/lebenslauf" onClick={() => {setIsOpen(false)}}>
                    <p className={pathname === "/lebenslauf" ? "current-page" : ""}>{isEnglish ? "CV" : "Lebenslauf"}</p>
                </Link>
                <Link to="/publikationen" onClick={() => {setIsOpen(false)}}>
                    <p className={pathname === "/publikationen" ? "current-page" : ""}>{isEnglish ? "Publications" : "Publikationen"}</p>
                </Link>
                <Link to="/projekte" onClick={() => {setIsOpen(false)}}>
                    <p className={pathname === "/projekte" ? "current-page" : ""}>{isEnglish ? "Projects" : "Projekte"}</p>
                </Link>
                <Link to="/lehre" onClick={() => {setIsOpen(false)}}>
                    <p className={pathname === "/lehre" ? "current-page" : ""}>{isEnglish ? "Teaching" : "Lehre"}</p>
                </Link>
                
                <ButtonComponent onClick={() => {setIsOpen(false)}} title={isEnglish ? "Contact" : "Kontakt"} to="/kontakt" />
            </div>
        </>
    )
}

export default HeaderComponent;